import React, { useEffect, useState } from 'react';
import { LeftIcon } from '../common/icon';
import { isMobile } from '@/biz/tool';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import axiosInstance from '@/apis/axiosInstance';
import { AGREEMENT_CONTENT } from './config';

export const InfluencerAgreement: React.FC<{
  setIsShowAgreement: Function;
}> = ({ setIsShowAgreement }) => {
  const { t } = useTranslation();

  const [agreementContent, setAgreementContent] =
    useState<string>(AGREEMENT_CONTENT);
  const getAgreementContent = async () => {
    try {
      const { data } = await axiosInstance.post('/ops/notion/markdown', {
        url: 'https://chartreuse-wrinkle-697.notion.site/Influencer-Agreement-1b404daded68803aba55e5eb8713b2eb'
      });
      const content = data?.data?.markdownString || '';
      const processedContent = content.replace(/\n/g, '\n\n');
      setAgreementContent(processedContent || AGREEMENT_CONTENT);
    } catch (error) {
      console.error(error);
      setAgreementContent(AGREEMENT_CONTENT);
    }
  };

  useEffect(() => {
    getAgreementContent();
  }, []);

  return (
    <div
      className={`bg-white rounded-lg 
      ${isMobile() ? 'h-[60vh] w-full' : 'h-[70vh] w-full'}
    `}
    >
      <div className="h-[40px] relative flex items-center justify-between px-0 py-4 border-b border-gray-200 w-full">
        <button
          onClick={() => setIsShowAgreement(false)}
          className="text-gray-500 hover:text-gray-700 flex items-center gap-2"
        >
          <LeftIcon className="w-10 h-10" />
          <span className="font-bold text-[#1c2024]">
            {t('campaign.agreement.back_btn', { defaultValue: 'Back' })}
          </span>
        </button>
        <h1
          className={`text-xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-semibold text-gray-800 mb-2 text-nowrap`}
        >
          {isMobile()
            ? t('campaign.agreement.title_mobile', {
                defaultValue: 'Agreement'
              })
            : 'Influencer Agreement'}
        </h1>
      </div>

      {/* 协议正文 */}
      <div className="flex-1 overflow-y-auto px-6 py-4 h-[calc(100%-40px)]">
        <div className="agreement-content">
          <ReactMarkdown
            components={{
              p: ({ children }) => (
                <p className="mb-4 text-gray-700 leading-relaxed">{children}</p>
              ),
              h1: ({ children }) => (
                <h1 className="text-2xl font-bold text-gray-900 mb-4 mt-6 first:mt-0">
                  {children}
                </h1>
              ),
              h2: ({ children }) => (
                <h2 className="text-xl font-semibold text-gray-800 mb-3 mt-5">
                  {children}
                </h2>
              ),
              h3: ({ children }) => (
                <h3 className="text-lg font-medium text-gray-800 mb-2 mt-4">
                  {children}
                </h3>
              ),
              ul: ({ children }) => (
                <ul className="list-disc list-inside mb-4 text-gray-700 space-y-1">
                  {children}
                </ul>
              ),
              ol: ({ children }) => (
                <ol className="list-decimal list-inside mb-4 text-gray-700 space-y-1">
                  {children}
                </ol>
              ),
              li: ({ children }) => (
                <li className="text-gray-700">{children}</li>
              ),
              strong: ({ children }) => (
                <strong className="font-semibold text-gray-800">
                  {children}
                </strong>
              ),
              em: ({ children }) => (
                <em className="italic text-gray-700">{children}</em>
              ),
              hr: () => <hr className="border-gray-300 my-6" />,
              blockquote: ({ children }) => (
                <blockquote className="border-l-4 border-gray-300 pl-4 italic text-gray-600 my-4">
                  {children}
                </blockquote>
              )
            }}
          >
            {agreementContent}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};
